import axios from "@/lib/request";

export const upload = (data) => {
  return axios.request({
    url: "/res/file/upload",
    method: "post",
    data,
  });
};

// ===== 雇主险方案管理相关接口 =====

// 获取雇主险方案列表
export const getEmployerInsuranceList = (params) => {
  return axios.request({
    url: "/v1/admin/ygb/product/list",
    method: "get",
    params,
    headers: {
      'AppKey': 'BpLnfgDs'
    }
  });
};

// 保存雇主险方案
export const saveEmployerInsurance = (data) => {
  return axios.request({
    url: "/v1/admin/ygb/product/save",
    method: "post",
    data,
    headers: {
      'AppKey': 'BpLnfgDs'
    }
  });
};

// 获取保险公司列表
export const getInsuranceCompanyList = (params) => {
  return axios.request({
    url: "/v1/admin/cmn/insurance/company/list",
    method: "get",
    params,
    headers: {
      'AppKey': 'BpLnfgDs'
    }
  });
};

// 获取产品列表
export const getProductList = (params) => {
  return axios.request({
    url: "/v1/admin/cmn/product/list",
    method: "get",
    params,
    headers: {
      'AppKey': 'BpLnfgDs'
    }
  });
};